import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { formsApi } from '@/lib/api';

export function useFormSubmissions(params?: Parameters<typeof formsApi.list>[0]) {
  return useQuery({
    queryKey: ['formSubmissions', params],
    queryFn: () => formsApi.list(params),
  });
}

export function useFormSubmission(id: string | undefined) {
  return useQuery({
    queryKey: ['formSubmissions', id],
    queryFn: () => formsApi.getById(id!),
    enabled: !!id,
  });
}

export function useProcessSubmission() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => formsApi.process(id),
    onSuccess: (_data, id) => {
      qc.invalidateQueries({ queryKey: ['formSubmissions'] });
      qc.invalidateQueries({ queryKey: ['formSubmissions', id] });
      qc.invalidateQueries({ queryKey: ['deals'] });
    },
  });
}

export function useDeleteSubmission() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => formsApi.remove(id),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['formSubmissions'] });
    },
  });
}
